import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { environment } from '../../environments/environment';
import { IPrayerTopic } from './interfaces';

export declare interface IListMeta {
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
};

export interface IFilter {
  page: number;
  pageSize: number;
  startDate: Date;
  endDate: Date;
  vicarId: number;
  churchId: number;
  organistId: number;
  year: number;
  sortDirection?: 'ASC' | 'DESC'
}

@Injectable()
export class PrayerTopicsService {

  public prayerTopics$: Subject<IPrayerTopic[]> = new Subject();
  public meta$: Subject<IListMeta> = new Subject();

  constructor( private http: Http ) {
  }

  selectPrayerTopicsAllFetch() {
    return this.prayerTopics$.asObservable();
  }

  selectMeta() {
    return this.meta$;
  }

  dispatchPrayerTopicsAllFetch( page: number = 1, pageSize: number = 1000 ): void {
    const url = environment.endPoint + `prayer-topics/current?page=${page}&page_size=10000&sort=-sortIndex`;

    this.http.get( url )
    .subscribe( ( response ) => {
      const payload = <IPrayerTopic[]>response.json();
      this.prayerTopics$.next( payload );
      console.log( '===>', response.headers.get( 'PaginationInfo' ) );
      this.meta$.next( JSON.parse( response.headers.get( 'PaginationInfo' ) ) )
    } );
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/prayer-topics.service.ts